<button mat-icon-button [matMenuTriggerFor]="languageMenu" (menuOpened)="loadData()">
    <mat-icon matBadge="."
              matBadgePosition="below after"
              matBadgeSize="small"
              aria-hidden="false"
              [matBadgeHidden]="!notificationPresent()"
              class="symbol">notifications
    </mat-icon>
</button>

<mat-menu #languageMenu='matMenu' xPosition="before" yPosition="below" class="notification-menu">
    @for (model of models(); track model.id) {
        <mat-card>
            <strong>{{ 'meal-plan-model.status.approval_title' | translate }}</strong>
            <span class="modified-at">{{ model.modifiedAt }}</span>
            <span>
                {{
                    'meal-plan-model.status.approval_description' | translate:{
                        name: model.name,
                        user: model.modifiedBy
                    }
                }}
            </span>
            <button mat-button
                    [disabled]="loadingModelId() === model.id"
                    (click)="jumpToModel(model)">
                @if (loadingModelId() === model.id) {
                    <mat-progress-spinner mode="indeterminate" [diameter]="16"></mat-progress-spinner>
                } @else {
                    {{ 'meal-plan-model.status.approval_view' | translate }}
                }
            </button>
        </mat-card>
    }
    @if (!notificationPresent()) {
        <div>{{ 'meal-plan-model.status.no_approvals' | translate }}</div>
    }
</mat-menu>
